import { useState } from "react";

import useCsvUploader from "./csvUploader";

import { transactionsFieldOptions } from "../../helpers/components/tasks";

const knownFields = [
  { header: "date", field: "date" },
  { header: "vendor", field: "vendor" },
  { header: "memo", field: "vendor" },
  { header: "value", field: "amount" },
  { header: "total", field: "amount" },
  { header: "amount", field: "amount" },
  { header: "category", field: "category" },
  { header: "description", field: "category" },
];

const fieldValidator = (headers) => {
  const fieldsBoolean = transactionsFieldOptions
    .filter(({ required }) => required)
    .map(({ value }) => value)
    .reduce(
      (booleanAcc, requiredField) =>
        booleanAcc &&
        headers.find(({ field }) => requiredField.toLowerCase() === field),
      true
    );

  return {
    success: fieldsBoolean,
    message:
      !fieldsBoolean &&
      `The fields Date, Vendor, and Value are required for this CSV.`,
  };
};

const useTransactionsUploader = ({ open, setOpen }) => {
  const [fileInfo, setFileInfo] = useState({});
  const [matchedHeaders, setMatchedHeaders] = useState([]);

  const csvUploaderSteps = useCsvUploader({
    knownFields,
    fieldOptions: transactionsFieldOptions,
    open,
    setOpen,
    fileInfo,
    setFileInfo,
    matchedHeaders,
    setMatchedHeaders,
    fieldValidator,
    docType: "transactions",
    firstStepText:
      "Upload a CSV of your transactions and we'll automatically convert them into emissions.",
    requiredFields: transactionsFieldOptions
  });

  return csvUploaderSteps;
};
export default useTransactionsUploader;
